import { StoreLayout } from "../../components/StoreLayout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { fmtINR } from "../../lib/api";
import { CheckCircle } from "@phosphor-icons/react";

export default function BookingConfirmed() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const count = state?.count || 0;
  const total = state?.total || 0;

  return (
    <StoreLayout>
      <div className="max-w-xl mx-auto px-5 py-20 text-center" data-testid="booking-confirmed">
        <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto">
          <CheckCircle size={44} weight="fill" className="text-green-600" />
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mt-6">Booking Confirmed!</h1>
        <p className="text-muted-foreground mt-2">
          {count} service{count !== 1 ? "s" : ""} booked{total ? ` · estimated ${fmtINR(total)}` : ""}.
          We're assigning a verified professional and will keep you updated.
        </p>
        <div className="flex gap-3 justify-center mt-8">
          <Button className="rounded-sm" onClick={() => navigate("/account/requests")} data-testid="view-my-requests">Track My Requests</Button>
          <Button variant="outline" className="rounded-sm" onClick={() => navigate("/services")}>Book Another</Button>
        </div>
      </div>
    </StoreLayout>
  );
}
